import { m, AnimatePresence } from "framer-motion";
import { useTranslation } from "react-i18next";

interface Props {
  open: boolean;
  text?: string;
  logo?: string;
}

export function LoadingModal({
  open,
  text,
  logo = "/pactline.png",
}: Props) {
  const { t } = useTranslation("common");
  return (
    <AnimatePresence>
      {open && (
        <m.div
          className="
                        fixed inset-0 z-[999]
                        flex items-center justify-center
                        bg-black/60 backdrop-blur-md
                    "
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
        >
          <m.div
            initial={{ scale: 0.9, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            exit={{ scale: 0.9, opacity: 0 }}
            transition={{ duration: 0.25 }}
            className="
                            rounded-2xl
                            bg-[rgb(var(--card))]
                            shadow-2xl
                            px-10 py-10
                            flex flex-col items-center gap-5
                            border border-[rgb(var(--border))]
                        "
          >
            {/* LOGO CONTAINER */}
            {/* LOGO CONTAINER */}
            <div className="relative flex items-center justify-center h-32 w-32">
              {/* Glow background */}
              <div
                className="
        absolute inset-0 rounded-full
        blur-xl opacity-40
        bg-[rgb(var(--accent-fill))]
        animate-pulse z-0
    "
              />

              {/* Big Logo */}
              <img
                src={logo}
                alt="PACTLINE"
                className="h-32 w-32 object-contain relative z-10"
              />
            </div>

            {/* TEXT */}
            <p className="text-base font-medium text-[rgb(var(--text-primary))]">
              {text ?? t("loading")}
            </p>
          </m.div>
        </m.div>
      )}
    </AnimatePresence>
  );
}
